import { render, staticRenderFns } from "./MarginalityByProductReport.vue?vue&type=template&id=c128099e&"
import script from "./MarginalityByProductReport.vue?vue&type=script&lang=ts&"
export * from "./MarginalityByProductReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports